import { createFileRoute } from "@tanstack/react-router";
import { ExerciseResults } from "@/components/exercise-results";
import { useT } from "@/glossary";

export const Route = createFileRoute("/train/results")({
  component: TrainResults,
});

function TrainResults() {
  const t = useT();
  return (
    <ExerciseResults
      id="train"
      nextStep={{ label: t.train.challengeYourEarLink, to: "/omo/exercise" }}
    />
  );
}
